
function Head(props) {

  return (
    <div className="head">
      <div className="head-cont">
        <div className="head-cont-title">
          <img src={'/assets/logo/kir1.png'} alt="logo" />
          <h1>
          {localStorage.getItem('language') == 'fa' ? 'مدیریت سرمایه کرگدنی' : 'Rhino Money Management'}
          </h1>
        </div>
      </div>
      {props.logo != false &&
        <div className="head-logo" >
          <img src={'/assets/logo/w.png'} alt="logo" />
        </div>
      }
    </div>
  );
}

export default Head;